import { HOME_URL } from '../constant';
import isEmpty from 'lodash/isEmpty';

export const pause = delay => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, delay.millis);
    });
};

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param function function Function to invoke
 * @param wait time in ms to wait.
 * @param immediate boolean trigger the function on the leading edge, instead of the trailing.
 * @returns function
 */

export const debounce = (func, wait, immediate) => {
    let timeout;
    const debounced = (...args) => {
        const context = this;
        const later = () => {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };

    debounced.cancel = () => {
        clearTimeout(timeout);
        timeout = null;
    };

    return debounced;
};

export const getCookieValue = name => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

export const getSessionId = () => {
    const sessionId = getCookieValue('iam-sessionid');
    return sessionId ? sessionId : null;
};

/**
 * If you do a GET /login-requests/{extid} and get back a valid response from API or
 * If iam-sessionid cookie is present then that means auth_req_exists is true
 * @param {?Object} loginRequest - login request object get from API
 * @returns {Boolean} - if the auth_Request exist
 */
export const authRequestExist = loginRequest => {
    // Return true if getSessionId exist or loginRequest doesn't empty
    return !!getSessionId() || !isEmpty(loginRequest);
};

/**
 * Reture the value of 'is_user_loggedin' property from connector
 * if the connector exist and has property 'is_user_loggedin'
 * otherwise always return false (default value)
 * @param {?number} numberOfConnectors - nunmber of connectors
 * @param {?Object} loginRequest - login request object get from API
 * @returns {Boolean} - is_user_loggedin value
 */
export const isUserLoggedIn = (numberOfConnectors, loginRequest) => {
    return !numberOfConnectors || !loginRequest?.isUserLoggedin
        ? false
        : loginRequest?.isUserLoggedin;
};

/**
 * get the value of 'isServiceProviderEnabled' property from connector
 * if the connector exist and has property 'isServiceProviderEnabled'
 * otherwise always return false (default value)
 * @param {*} loginRequest - login request object get from API
 * @returns  {Boolean} - isServiceProviderEnabled value
 */
export const getServiceProviderEnabled = loginRequest => {
    return loginRequest?.isServiceProviderEnabled;
};

/**
 * Handles force redirect in browser
 * @param {String} url - redirect url
 * @returns {void}
 */
export const forceRedirect = (url = HOME_URL) => {
    window.location.href = url;
};
